module.exports = __webpack_public_path__ + "media/images/salon-logo-5dddd1bd76bda05b46d9ff4061a6db36.svg";